import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Stream } from 'src/models/stream';
import { ListStreamsI } from '../../base/list-streams/list-streams-i';
import { Country } from 'src/models/country';
import { ActivatedRoute } from '@angular/router';
import { StreamService } from 'src/app/services/stream.service';

@Component({
  selector: 'app-sports',
  templateUrl: './sports.component.html',
  styleUrls: ['./sports.component.scss']
})
export class SportsComponent implements OnInit, ListStreamsI {

  public countries = new Array<Country>();

  public countryId: string;

  constructor(private activatedRoute: ActivatedRoute, private streamService: StreamService) {}

  ngOnInit() {
    this.streamService.getCountriesWithSportStations().subscribe((value: Country[]) => {
      this.countries = value;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.countryId = params['id'];
    });
  }

  public getHeadline(): string {
    const country = this.countries.find((country: Country) => country.id === this.countryId);

    return country !== undefined ? country.name : 'Alle';
  }

  public getStreamsObservable(start: number, itemsPerPage: number): Observable<Stream[]> {
    const observable = this.countryId !== undefined
                            ? this.streamService.getSportsStationsByCountry(this.countryId, start, itemsPerPage)
                            : this.streamService.getStationsByCategory(55, start, itemsPerPage);

    return observable;
  }

}
